module.exports = require("lodash/slice");


//////////////////
// WEBPACK FOOTER
// external "lodash/slice"
// module id = 292
// module chunks = 0